var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostgresql(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 163.28 168.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);stroke:url(#linear-gradient-2);stroke-miterlimit:10;stroke-opacity:.44;stroke-width:16px;}.cls-2{stroke-width:2.08px;}.cls-2,.cls-3{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#fff;}.cls-3{stroke-width:4.16px;}.cls-4,.cls-5{stroke-linejoin:round;}.cls-4,.cls-5,.cls-6{stroke-linecap:round;}.cls-4,.cls-6{fill:none;stroke-width:2px;}.cls-5{fill:rgba(255,255,255,.25);}.cls-6{stroke-linejoin:bevel;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.16,
    y1: 8.62,
    x2: 143.74,
    y2: 124.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 84.16,
    x2: 163.28,
    y2: 84.16,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.49,122.06c1.06-8.81,.74-10.1,7.3-8.68l1.67,.15c5.05,.23,11.65-.81,15.53-2.61,8.35-3.87,13.3-10.34,5.07-8.64-18.78,3.87-20.07-2.48-20.07-2.48,19.83-29.42,28.12-66.76,20.96-75.91-19.51-24.93-53.29-13.14-53.86-12.84l-.18,.03c-3.71-.77-7.86-1.23-12.53-1.31-8.5-.14-14.94,2.23-19.84,5.94,0,0-60.26-24.83-57.45,31.22,.6,11.92,17.09,90.22,36.76,66.57,7.19-8.65,14.14-15.96,14.14-15.96,3.45,2.29,7.58,3.46,11.91,3.04l.33-.29c-.1,1.07-.06,2.12,.13,3.37-5.07,5.66-3.58,6.66-13.71,8.74-10.25,2.11-4.23,5.87-.3,6.86,4.77,1.19,15.79,2.88,23.25-7.55l-.3,1.19c1.99,1.59,1.85,11.43,2.14,18.46,.28,7.03,.75,13.59,2.19,17.46,1.43,3.87,3.12,13.83,16.44,10.98,11.13-2.38,19.64-5.82,20.41-37.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.42,107.97c-.52,18.49,.13,37.1,1.94,41.62,1.81,4.52,5.68,13.32,19,10.47,11.13-2.39,15.18-7,16.93-17.19,1.29-7.5,3.79-28.32,4.11-32.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.46,15.3S5.16-9.34,7.96,46.7c.6,11.92,17.09,90.22,36.76,66.57,7.19-8.65,13.69-15.43,13.69-15.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.03,10.8c-2.09,.65,33.54-13.02,53.79,12.85,7.15,9.14-1.14,46.49-20.96,75.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.85,99.56s1.29,6.36,20.07,2.48c8.23-1.7,3.28,4.77-5.07,8.64-6.85,3.18-22.2,3.99-22.45-.4-.65-11.33,8.08-7.89,7.45-10.73-.57-2.56-4.47-5.07-7.05-11.33-2.25-5.46-30.91-47.36,7.95-41.13,1.42-.29-10.13-36.96-46.5-37.56-36.36-.6-35.16,44.71-35.16,44.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.24,103.44c-5.07,5.66-3.58,6.66-13.71,8.74-10.25,2.11-4.23,5.87-.3,6.86,4.77,1.19,15.79,2.88,23.25-7.55,2.27-3.18-.01-8.25-3.13-9.54-1.51-.62-3.52-1.41-6.11,1.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.91,103.34c-.51-3.33,1.09-7.29,2.81-11.92,2.58-6.95,8.55-13.91,3.78-35.97-3.56-16.44-27.4-3.42-27.42-1.19-.01,2.23,1.08,11.3-.4,21.86-1.93,13.78,8.77,25.44,21.08,24.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.24,53.92c-.11,.76,1.39,2.79,3.35,3.06,1.95,.27,3.63-1.31,3.73-2.08,.11-.76-1.39-1.6-3.35-1.87-1.96-.27-3.63,.12-3.73,.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.75,52.37c.11,.76-1.39,2.79-3.35,3.06-1.96,.27-3.63-1.31-3.74-2.08-.1-.76,1.4-1.6,3.35-1.87s3.63,.12,3.73,.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.75,47.1c.32,5.97-1.29,10.04-1.49,16.39-.3,9.24,4.4,19.81-2.68,30.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.06,102.28c-18.78,3.87-20.07-2.48-20.07-2.48,19.83-29.42,28.12-66.77,20.96-75.91-19.51-24.93-53.29-13.14-53.86-12.83l-.18,.03c-3.71-.77-7.86-1.23-12.53-1.31-8.5-.14-14.94,2.23-19.83,5.94,0,0-60.26-24.82-57.46,31.22,.6,11.92,17.09,90.22,36.76,66.57,7.19-8.65,14.14-15.96,14.14-15.96,3.45,2.29,7.58,3.46,11.91,3.04l.34-.29c-.1,1.07-.06,2.12,.13,3.37-5.07,5.66-3.58,6.66-13.71,8.74-10.25,2.11-4.23,5.87-.3,6.86,4.77,1.19,15.79,2.88,23.25-7.55l-.3,1.19c1.99,1.59,3.38,10.35,3.15,18.28-.23,7.94-.39,13.39,1.17,17.64,1.56,4.26,3.12,13.83,16.44,10.98,11.13-2.38,16.9-8.56,17.7-18.87,.57-7.33,1.86-6.25,1.94-12.8l1.03-3.1c1.19-9.93,.19-13.14,7.05-11.65l1.67,.15c5.05,.23,11.65-.81,15.53-2.61,8.35-3.87,13.3-10.34,5.07-8.64h0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostgresql);
export default __webpack_public_path__ + "static/media/postgresql.cd3de582445e69df3e3a6cef6f42003e.svg";
export { ForwardRef as ReactComponent };